module.exports = __webpack_public_path__ + "static/media/logo_equipe.79a7e89b.png";